import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { gql, useMutation } from 'urql';
import { useCurrentUser } from '../hooks';
import { RoleName } from '../types';
import { AuthorizationType, HacpackMutation, HacpackMutationDeleteHandlingsHarbourOfficeApprovalsArguments, Handling, Terminal } from '../types/graph';

type TerminalHandlingHarbourOfficeAuthorizationProps = {
    terminal: Terminal,
    handling: Handling,
};

type HacpackMutationChangeHandlingPositionResult = Pick<HacpackMutation, 'deleteHandlingsHarbourOfficeApprovals'>;

const changeHandlingPositionMutation = gql<HacpackMutationChangeHandlingPositionResult, HacpackMutationDeleteHandlingsHarbourOfficeApprovalsArguments>`
    mutation ($handlingIds: [Long!]!) {
        deleteHandlingsHarbourOfficeApprovals(handlingIds: $handlingIds)  {
            isOk
        }
    }
`;

const TerminalHandlingHarbourOfficeAuthorization = ({ terminal, handling }: TerminalHandlingHarbourOfficeAuthorizationProps) => {

    const [result, deleteHandlingsHarbourOfficeApprovals] = useMutation<HacpackMutationChangeHandlingPositionResult, HacpackMutationDeleteHandlingsHarbourOfficeApprovalsArguments>(changeHandlingPositionMutation);
    const { error, fetching: fetchingApproval } = result;

    const { isSuperuser, hasRoleForTerminal } = useCurrentUser();

    const [promptOpen, setPromptOpen] = useState(false);

    const { t } = useTranslation('common');
    const handlingId = handling?.id;
    const harbourOfficeAuthorization = handling?.harbourOfficeAuthorization;

    const togglePrompt = useCallback(() => setPromptOpen(promptOpen => !promptOpen), [setPromptOpen])

    const handlPromptButtonClick = useCallback(() => {
        setPromptOpen(true);
    }, [setPromptOpen]);

    const canDeleteApprovation = useMemo(() => {
        if (isSuperuser || /*hasRoleForTerminal(RoleName.USER, terminal.id as number) ||*/ hasRoleForTerminal(RoleName.ADMIN, terminal.id as number)) {
            return true;
        }

        return false;
    }, [terminal, hasRoleForTerminal, isSuperuser]);

    const handleDeleteButtonClick = useCallback(() => {
        if (handlingId === undefined) {
            return;
        }

        const args: HacpackMutationDeleteHandlingsHarbourOfficeApprovalsArguments = {
            handlingIds: [handlingId]
        };

        deleteHandlingsHarbourOfficeApprovals(args).then(({ data }) => {
            console.log(data);
            if (data?.deleteHandlingsHarbourOfficeApprovals?.isOk !== true) {
                return;
            }
            window.location.reload();
        });
    }, [handlingId]);

    const authorization = useMemo(() => {
        switch (harbourOfficeAuthorization?.authorization) {
            case AuthorizationType.Boarding:
                return 'Autorizzazione all\'imbarco.';
            case AuthorizationType.Unboarding:
                return 'Autorizzazione allo sbarco.';
            case AuthorizationType.Transit:
                return 'Autorizzazione al transito.';
        }
    }, [harbourOfficeAuthorization, t]);

    const prompt = useMemo(() => <div>
        <Modal isOpen={!fetchingApproval && promptOpen} toggle={togglePrompt}>
            <ModalHeader>{t('Elimina approvazione della Capitaneria')}</ModalHeader>
            <ModalBody>{t('Confermi l\'eliminazione?')}</ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleDeleteButtonClick}>{t('Conferma')}</Button>{' '}
                <Button color="secondary" onClick={togglePrompt}>{t('Annulla')}</Button>
            </ModalFooter>
        </Modal>
    </div>, [t, handleDeleteButtonClick, promptOpen, togglePrompt, fetchingApproval])

    const deleteButton = useMemo(() => {
        if (!canDeleteApprovation) {
            return;
        }

        return <>{' '} <Button color='danger' disabled={fetchingApproval} type='button' onClick={handlPromptButtonClick}>{t('Elimina')}</Button></>
    }, [fetchingApproval, t, canDeleteApprovation, handlPromptButtonClick]);

    if (handlingId === undefined || harbourOfficeAuthorization === undefined || harbourOfficeAuthorization === null) {
        return null;
    }

    return <div className="card card-body bg-light">
        <h4 className="card-title">{t('Approvazione della Capitaneria')}</h4>
        <p className="card-text">{authorization}{deleteButton}</p>
        
        {prompt}
    </div>
    //<p><b>{t('Approvazione Capitaneria')}:</b> {authorization} <Button color='danger' disabled={fetching} type='button' onClick={handleDeleteButtonClick}>{t('Elimina')}</Button></p>
};

export default TerminalHandlingHarbourOfficeAuthorization;